/**
 * Writes the text to the clipboard.
 *
 * @param toWriteToClipboard The text to write to the clipboard.
 * @returns A promise that resolves when the text is written to the clipboard.
 */
export async function writeText(toWriteToClipboard: string): Promise<void> {
	await navigator.clipboard.writeText(toWriteToClipboard);
}
